import * as React from 'react';
import { Flex, Text } from "./..";
import { CheckboxIcon } from "./CheckboxIcon";
var sizeToIconSize = {
  large: 'medium',
  medium: 'small',
  small: 'tiny',
  tiny: 'tiny'
};
var sizeToFontSize = {
  large: 3,
  medium: 2,
  small: 1,
  tiny: 0
};
var sizeToTextMargin = {
  large: 2,
  medium: 2,
  small: 1,
  tiny: 1
};
export var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$indeterminate = _ref.indeterminate,
      indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
      onChange = _ref.onChange,
      dataTestId = _ref['data-test-id'];

  var handleChange = function handleChange(event) {
    if (disabled) return;
    onChange(checked, event);
  };

  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    "data-test-id": dataTestId
  }, /*#__PURE__*/React.createElement(CheckboxIcon, {
    checked: checked,
    disabled: disabled,
    indeterminate: indeterminate,
    size: sizeToIconSize[size],
    onClick: handleChange,
    "data-test-id": "icon"
  }), /*#__PURE__*/React.createElement(Text, {
    ml: sizeToTextMargin[size],
    fontSize: sizeToFontSize[size],
    "data-test-id": "label"
  }, label));
};